import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[gstarContainer]',
})
export class ContainerDirective {
  readonly viewContainerRef = inject(ViewContainerRef);
}
